import { createAction } from '@reduxjs/toolkit';

import { type Plan } from '@/utils/mapProductObject';

// switches to payment methods step and selects a plan
export const selectPlanAndProceed = createAction<Plan>('selectPlanAndProceed');
